import { useEffect, useMemo, useState } from 'react';
import { IHttpService, HttpService } from '../../../services/httpService';
import {
	INotifierService,
	NotifierService
} from '../../../services/notifierService';
import { IBaseResponseModel } from '../../../models/common/BaseResponseModel';
import { IServiceShareInputSearchResponseModel } from '../../../models/serviceShareInput/ServiceShareInputSearchResponseModel';
import { useServiceShareInputFilters } from '../filters/hooks/useServiceShareFilters';
import { IServiceShareInputSearchRequestModel } from '../../../models/serviceShareInput/ServiceShareInputSearchRequestModel';
import { useWatch } from 'react-hook-form';
import { IServiceShareFiltersModel } from '../../../models/serviceShareInput/ServiceShareFiltersModel';

export const useServiceShareInput = () => {
    const httpService: IHttpService = useMemo(() => new HttpService(), []);
	const notifierService: INotifierService = useMemo(
		() => new NotifierService(),
		[]
	);

    const [isLoading, setIsLoading] = useState<boolean>(false);
	const [shouldRefetch, setShouldRefetch] = useState<boolean>(false);

    const [serviceShareInputs, setServiceShareInputs] =
        useState<IBaseResponseModel<IServiceShareInputSearchResponseModel>>();

    const { isFiltersReady, filtersControl, handlePageChange, clearFilters, searchDistributors} = useServiceShareInputFilters();

    const filtersValues = useWatch<IServiceShareFiltersModel>({control: filtersControl});

	const triggerRefetch = () => {
		setShouldRefetch((value) => !value);
	}

	const handleFetchData = async (filters: IServiceShareInputSearchRequestModel) => {
		await httpService
			.postGeneric<
				IBaseResponseModel<IServiceShareInputSearchResponseModel>
			>(
				`serviceShareInputs/search`,
				JSON.stringify(filters),
				undefined,
				false
			)
			.then((serviceShareInputs) => {
				setServiceShareInputs(serviceShareInputs);
			})
			.catch(() => notifierService.error());
	};

	useEffect(() => {
        if(filtersValues && isFiltersReady){
            setIsLoading(true);

            handleFetchData(filtersValues.filterValuesSelected as IServiceShareInputSearchRequestModel);

            setIsLoading(false);
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filtersValues.filterValuesSelected, isFiltersReady, shouldRefetch]);

	return {
		isLoading,
		serviceShareInputs,
        filtersControl,
		filtersValues,
		handlePageChange,
		triggerRefetch,
		clearFilters,
		searchDistributors
	};
};
